import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { finalize, map, Observable, Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import Swal from 'sweetalert2';
import { helper } from 'src/environments/helper';
import { PermissionsService } from 'src/app/services/permissions.service';
import { SubcategoriesService } from './subcategories.service';
import { AddSubcategoriesComponent } from './add-subcategories/add-subcategories.component';
import { EditSubcategoriesComponent } from './edit-subcategories/edit-subcategories.component';
import { Generic } from 'src/app/interfaces/generic.interface';
import { CategoriesService } from '../categories/categories.service';

@Component({
    selector: 'app-subcategories',
    templateUrl: './subcategories.component.html',
    styleUrls: ['./subcategories.component.scss']
})
export class SubcategoriesComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    isFilterLoading = false;
    showCard = false;
    activeValue: boolean | '-1' = '-1';
    publicValue: boolean | '-1' = '-1';
    categoryId: string = '-1';

    categorii: Generic[] = [];

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink = this.requestService.listDTUrl;

    defaultParameter: { name: string; id: string } = {
        name: 'Toate',
        id: '-1',
    };

    parameters: { key: string; value: boolean | '-1' }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: true },
        { key: 'Nu', value: false },
    ];

    resetForm() {
        this.activeValue = '-1';
        this.publicValue = '-1';
        this.categoryId = '-1';

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    loadCategoriesActive() {
        this.isLoading = true;
        this.categoriesService
            .getListActive()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.categorii = results;
                },
                error: (error) => {
                    console.error('Error loading categories', error);
                    this.isFilterLoading = false;
                },
            });
    }

    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private requestService: SubcategoriesService,
        private categoriesService: CategoriesService,
        public permissionsService: PermissionsService
    ) { }

    ngOnInit(): void {
        this.renderDT();
        this.loadCategoriesActive();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,
            pageLength: 25,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.active = this.activeValue;
                dataTablesParameters.public = this.publicValue;
                dataTablesParameters.id_category = this.categoryId;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            order: [[4, 'asc']],
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Denumire',
                    data: 'title',
                },
                {
                    title: 'Descriere',
                    data: 'description',
                },
                {
                    title: 'Categorie',
                    data: 'id_category',
                    render: (data: any, type: any, row: any) => {
                        return row.category.title
                    }
                },
                {
                    title: 'Poziție',
                    data: 'position',
                    sortable: true,
                    render: (data: any, type: any, row: any, met: any) => {
                        return (
                            `<div class="order-section-dt"> 
                                <button type="button" class="action-btn up-order btn btn-sm btn-primary" title="Poziție +1">
                                    <img class="btn-img" src="/assets/icons/down-white.svg" alt="down-order"/>
                                </button>
                                <span class="order">${row.position}</span>
                                <button type="button" class="action-btn down-order btn btn-sm btn-primary" 
                                    ${row.position == 0 ? 'disabled="true"' : ''} title="Poziție -1">
                                    <img class="btn-img" src="/assets/icons/up-white.svg" alt="up-order"/>
                                </button>
                            </div>`
                        );
                    },
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: (row: any) => {
                        return `
                        <div class="d-flex align-center justify-content-left">
                        <button class="action-btn edit ms-1">
                            <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
                        </button>
                        <button class="action-btn delete ms-1">
                            <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
                        </button>
                        <button type="button" class="action-btn update_status_active ms-1 ` +
                            (row.is_active == true ? 'action-success' : 'action-danger') +
                            `">
                                <img class="btn-img" src="` +
                            (row.is_active == true
                                ? '/assets/icons/check-white.svg'
                                : '/assets/icons/close-white.svg') +
                            `" alt="update_status_active"/>
                        </button>
                        <button type="button" class="action-btn update_status_public ms-1 ` +
                            (row.is_public == true
                                ? 'action-success'
                                : 'action-danger') +
                            `">
                            <img class="btn-img" src="` +
                            (row.is_public == true
                                ? '/assets/icons/public_white.svg'
                                : '/assets/icons/public_not_white.svg') +
                            `" alt="update_status_public"/>
                        </button>
                    </div>
            `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;
                const updateStatusActiveIcon = lastTd?.querySelector(
                    '.update_status_active'
                ) as HTMLElement;
                const updateStatusPublicIcon = lastTd?.querySelector(
                    '.update_status_public'
                ) as HTMLElement;

                const orderTD = (row as HTMLElement).querySelector('td:nth-last-child(2)');
                const upOrderInSection = orderTD?.querySelector(
                    '.up-order'
                ) as HTMLElement;
                const downOrderInSection = orderTD?.querySelector(
                    '.down-order'
                ) as HTMLElement;

                if (editIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.bulevart-settings.subcategory.update'
                        )
                    ) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.bulevart-settings.subcategory.delete'
                        )
                    ) {
                        deleteIcon.style.display = 'none';
                    }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.deleteCerere(id);
                    });
                }

                if (updateStatusActiveIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.bulevart-settings.subcategory.update-status'
                        )
                    ) {
                        updateStatusActiveIcon.style.display = 'none';
                    }
                    updateStatusActiveIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.changeStatusActive(id);
                    });
                }

                if (updateStatusPublicIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.bulevart-settings.subcategory.update-status'
                        )
                    ) {
                        updateStatusPublicIcon.style.display = 'none';
                    }
                    updateStatusPublicIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.changeStatusPublic(id);
                    });
                }

                if (upOrderInSection) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.bulevart-settings.subcategory.update-order'
                        )
                    ) {
                        upOrderInSection.style.display = 'none';
                    }
                    upOrderInSection.addEventListener('click', () => {
                        const { id } = data;
                        this.updatePositionInSection(id, 1);
                    });
                }

                if (downOrderInSection) {
                    if (
                        !this.permissionsService.hasPermission(
                            'auth-module.bulevart-settings.subcategory.update-order'
                        )
                    ) {
                        downOrderInSection.style.display = 'none';
                    }
                    downOrderInSection.addEventListener('click', () => {
                        const { id } = data;
                        this.updatePositionInSection(id, -1);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    updatePositionInSection(id: number, index: number) {
        this.isLoading = true;

        this.requestService.updatePosition(id, index).subscribe(
            () => {
                this.rerenderDT();
            },
            (err) => {
                this.rerenderDT();
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }

                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                });
            }
        );
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddSubcategoriesComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare adăugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditSubcategoriesComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    deleteCerere(id: number) {
        Swal.fire({
            title: 'Sunteți sigur?',
            text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Confirm!',
            cancelButtonText: 'Cancel',
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.requestService.deleteEntry(id).subscribe(() => {
                    this.rerenderDT();
                    Swal.fire({
                        title: 'Șters!',
                        text: 'Înregistrare ștearsă cu succes.',
                        icon: 'success',
                        confirmButtonText: 'OK',
                    });
                });
            }
        });
    }

    changeStatusActive(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul înregistrării selectate!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusActiveAction(id);
            }
        });
    }

    changeStatusActiveAction(id: number) {
        this.isLoading = true;
        console.log(id);
        this.requestService.changeStatusActive(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err: any) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusActiveAction(id);
                    }
                });
            }
        );
    }

    changeStatusPublic(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul înregistrării selectate!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusPublicAction(id);
            }
        });
    }

    changeStatusPublicAction(id: number) {
        this.isLoading = true;
        this.requestService.changeStatusPublic(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusPublicAction(id);
                    }
                });
            }
        );
    }
}


